module.exports = __webpack_public_path__ + "img/bottomicon (4).014ba78c.png";